module.exports = __webpack_public_path__ + "img/female-ico.0b25bd95.svg";